import { useEffect } from "react";
import { getCalculationWorkTimeAsync } from "../../../store/features/NP/network/networkAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import CustomModal from "../../common/CustomModal";

export default function WorkDurationModal({ open, handleClose, data }: any) {
  const dispatch = useAppDispatch();
  const { calculationWorkDuration } = useAppSelector((state) => state.network);

  // const totalWorkingTime =
  //   (calculationWorkDuration?.totalValidRunTime || 0) / 60;

  // const totalPerMinuteChange = data?.perMinuteCharge || 0;
  // const sorOne = data?.sorOne || 0;

  // const totalAmount = calculationWorkDuration?.totalValidRunTime
  //   ? Math.round(1 * sorOne + totalWorkingTime * totalPerMinuteChange)
  //   : 0;

  useEffect(() => {
    dispatch(
      getCalculationWorkTimeAsync({
        params: { id: data?.id as string },
      })
    );
  }, [data?.id, dispatch]);

  return (
    <CustomModal
      width={450}
      title={"Work Duration"}
      open={open}
      handleClose={handleClose}
    >
      {" "}
      <div className="px-3.5 py-2.5 mb-3 bg-status-waiting-bg rounded-xl">
        <div className="flex justify-between items-center gap-2 mb-1">
          <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
            Total Duration:
          </div>
          <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
            {calculationWorkDuration?.totalPGRunHour || 0} minutes
            {/* {calculationWorkDuration?.totalValidRunTime || 0} minutes */}
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 mb-1">
          <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
            Rest in PG Duration:
          </div>
          <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
            {calculationWorkDuration?.totalRestTime || 0} minutes
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 mb-1">
          <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
            Claimable Duration:
          </div>
          <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
            {calculationWorkDuration?.totalValidRunTime || 0} minutes
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 mb-1">
          <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
            Total Site Down Time:
          </div>
          <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
            {calculationWorkDuration?.totalSdTime || 0} minutes
          </div>
        </div>
        <div className="flex justify-between items-center gap-2">
          <div className="text-status-danger-text text-base font-semibold font-['Inter'] leading-normal">
            Payable Bill:
          </div>
          <div className="text-others-info text-base font-medium font-['Inter'] leading-normal">
            {data?.totalAmount || 0} BDT
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
